import React from 'react';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page">
      <h1>About D Byron</h1>

      <section className="bio-section">
        <p>Hello. I’m D Byron — an independent author and musician.</p>
        <p>I’ve always worked outside institutions, labels, and permission. I write and make music not because I chose a career path, but because I have no choice in the matter. Creation is a compulsion. If I don’t make the work, it doesn’t leave me alone.</p>
        <p>In the old Greek sense, art isn’t the finished object — it’s the act itself. The doing is the art. The book, the album, the song is simply the trace left behind. That’s how I’ve always understood my work. I follow it where it leads, and once it exists, why not share it?</p>
        <p>I’ve been creating for many years, moving through music and literature in parallel. Only recently has the work begun to find a wider audience and attract critical attention, but the process hasn’t changed. The work comes first. Everything else follows.</p>
      </section>

      <section className="works-section">
        <h2>Published Works</h2>
        <ul>
          <li>Adrift</li>
          <li>Who Wrote the First Book of the Bible: And Why Did They Do It?</li>
          <li>HELL A FURY (Thriller)</li>
          <li>The Nature of Decisions: A Collection of Seven Short Stories</li>
        </ul>
      </section>

      <section className="music-section">
        <h2>Music Releases</h2>
        <ul>
          <li>The Antmen of Neopop (self-titled album)</li>
          <li>D Byron</li>
          <li>Selling Sounds on Planet Deaf</li>
          <li>File Under Unheard</li>
          <li>A Muse Made Me Do It</li>
          <li>Byron Schmyron</li>
        </ul>
      </section>
    </div>
  );
}

export default AboutPage;
